import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import { Layout, Spin, Card, Avatar, Skeleton } from "antd";

import { environment } from "./auth/apiRoute";
import PermissionChecker from "./auth/RolePermissionChecker";
import PrivateRoute from "./auth/privateRoute";
import LoginPage from "./auth/login";
import RegisterPage from "./auth/register";
import NotFound from "./pages/member/notFound";
import Onboarding from "./pages/member/onboarding";
import Addnomination from "./pages/member/addNomination";
import MyNominations from "./pages/member/myNominations";
import MyProfile from "./pages/member/myProfile";
import EditProfile from "./pages/member/profile";
import ProfileHotel from "./pages/member/profileHotel";
import Editnomination from "./pages/member/editNomination";
import Home from "./pages/member/home";
import PasswordResetRequest from "./auth/passwordResetRequest";
import ResetRequest from "./auth/resetPassword";
import AdminDashboard from "./pages/admin/dashboard";
import AdminAddnomination from "./pages/admin/addNomination";
import ViewNomination from "./pages/admin/viewNomination";
import Hotels from "./pages/admin/hotels";
import AdminEditNomination from "./pages/admin/editNomination";
import ViewNominationMember from "./pages/member/viewNomination";
import HotelProfile from "./pages/hotel/hotelProfile";
import Members from "./pages/admin/members";
import Judges from "./pages/admin/judges";
import JudgeDashboard from "./pages/judge/dashboard";
import JudgeRegister from "./pages/judge/register";
import JudgeApply from "./pages/judge/apply";
import JudgeProfile from "./pages/judge/profile";
import Finalist from "./pages/admin/finalist";
import FinalJudgeDashboard from "./pages/finalJudge/dashboard";
import Settings from "./pages/admin/settings";
export default function Routers(appProps) {
  const { Meta } = Card;
  const dev = appProps.environment;
  // const { pathname } = useLocation();
  const navigate = useNavigate();
  const ProtectedRoute = ({
    isLoading,
    user,
    isAuthenticated,
    redirectPath = "/login",
  }) => {
    // console.log(pathname);
    if (isLoading) {
      return <Skeleton active />;
    }

    if (!isAuthenticated) {
      return <Navigate to={redirectPath} replace />;
    }
    // if (!user.id && pathname != "/member/new/profile") {
    //   console.log("redirect to profile");
    //   return <Navigate to={"/member/new/profile"} replace />;
    // }
    return <Outlet />;
  };
  const AdminOnly = ({
    isLoading,
    isAuthenticated,
    user,
    redirectPath = "/",
  }) => {
    if (isLoading) {
      return <Skeleton active />;
    }

    if (isAuthenticated && user.roles.includes("admin")) {
      return <Outlet />;
    }

    return <Navigate to={redirectPath} replace />;
  };
  const JudgeOnly = ({
    isLoading,
    isAuthenticated,
    user,
    redirectPath = "/login/?next=/judge",
  }) => {
    if (isLoading) {
      return <Skeleton active />;
    }

    if (isAuthenticated) {
      return <Outlet />;
    }
    // if (isAuthenticated && user.roles.includes("judge")) {
    //   return <Outlet />;
    // }

    return <Navigate to={redirectPath} replace />;
  };
  const FinalJudgeOnly = ({
    isLoading,
    isAuthenticated,
    user,
    redirectPath = "/login/?next=/final-judge",
  }) => {
    if (isLoading) {
      return <Skeleton active />;
    }
    // return <Outlet />;
    if (
      isAuthenticated &&
      (user.roles.includes("final_judge") || user.roles.includes("admin"))
    ) {
      return <Outlet />;
    }

    return <Navigate to={redirectPath} replace />;
  };
  const JudgeRegistration = ({
    isLoading,
    isAuthenticated,
    user,
    redirectPath = "/",
  }) => {
    if (isLoading) {
      return <Skeleton active />;
    }

    if (isAuthenticated && !user.isPendingApproval) {
      return <Navigate to={"/judge"} replace />;
    }

    return <Outlet />;
  };
  const RedirectIfLogin = ({
    isLoading,
    isAuthenticated,
    redirectPath = "/",
  }) => {
    return <Outlet />;
    // if (isLoading) {
    //   return <Skeleton active />;
    // }
    // if (!isAuthenticated) {
    //   return <Outlet />;
    // }

    // return <Navigate to={redirectPath} replace />;
  };
  const LogoutPage = ({ isLoading, logout, redirectPath = "/" }) => {
    logout();
    navigate(0);
    return <Navigate to={redirectPath} replace />;
  };

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/404" replace />}></Route>
      <Route exact path="/404" element={<NotFound {...appProps} />} />
      <Route exact path="/" element={<Home {...appProps} />}></Route>
      <Route
        exact
        path="/reset-password"
        element={<PasswordResetRequest />}
      ></Route>
      <Route
        exact
        path="/set-password/:token"
        element={<ResetRequest />}
      ></Route>
      <Route
        exact
        path="/judge/apply"
        element={<JudgeApply {...appProps} />}
      ></Route>
      <Route
        exact
        path="/judge/register"
        element={<JudgeRegister {...appProps} />}
      ></Route>
      <Route
        exact
        path="/judge/profile"
        element={<JudgeProfile {...appProps} />}
      ></Route>
      <Route
        exact
        path="/logout"
        element={<LogoutPage {...appProps} />}
      ></Route>
      <Route>
        <Route element={<RedirectIfLogin {...appProps} />}>
          <Route
            exact
            path="/login"
            element={<LoginPage {...appProps} />}
          ></Route>
          <Route
            exact
            path="/register"
            element={<RegisterPage {...appProps} />}
          ></Route>
        </Route>
        {/*  Members Routes  */}

        <Route element={<ProtectedRoute {...appProps} />}>
          <Route
            exact
            path="/member/:userId/profile"
            element={<Onboarding {...appProps} />}
          ></Route>
          <Route
            key={"/member/profile"}
            exact
            path="/member/profile"
            element={<MyProfile {...appProps} />}
          ></Route>
          <Route
            key={"/member/profile/hotel"}
            exact
            path="/member/profile/hotel"
            element={<ProfileHotel {...appProps} />}
          ></Route>
          <Route
            exact
            path="/member/profile/edit"
            element={<EditProfile {...appProps} />}
          ></Route>
          <Route
            exact
            path="/member/nomination/add"
            element={<Addnomination {...appProps} />}
          ></Route>
          <Route
            exact
            path="/member/nomination/:nominationId"
            element={<ViewNominationMember {...appProps} />}
          ></Route>
          <Route
            key={"/member/nominations"}
            path="/member/nominations"
            element={<MyNominations {...appProps} />}
          ></Route>
          <Route
            exact
            path="/nomination/:nominationId/edit"
            element={<Editnomination {...appProps} />}
          ></Route>
          <Route
            exact
            path="/hotels/:hotelId"
            element={<HotelProfile {...appProps} />}
          ></Route>
        </Route>

        {/*  Admin Routes  */}
      </Route>
      <Route element={<AdminOnly {...appProps} />}>
        <Route
          exact
          path="/admin"
          {...appProps}
          element={<AdminDashboard />}
        ></Route>
        <Route
          exact
          path="/admin/add"
          {...appProps}
          element={<AdminAddnomination />}
        ></Route>
        <Route
          exact
          path="/admin/finalist"
          {...appProps}
          element={<Finalist />}
        ></Route>
        <Route
          exact
          path="/admin/users"
          {...appProps}
          element={<Members />}
        ></Route>
        <Route
          exact
          path="/admin/hotels"
          {...appProps}
          element={<Hotels />}
        ></Route>
        <Route
          exact
          path="/admin/judges"
          {...appProps}
          element={<Judges />}
        ></Route>
        <Route
          exact
          path="/admin/nominations/:nominationId"
          element={<ViewNomination {...appProps} />}
        ></Route>
        <Route
          exact
          path="/admin/nomination/:nominationId/edit"
          element={<AdminEditNomination {...appProps} />}
        ></Route>

        <Route
          exact
          path="/admin/settings"
          element={<Settings {...appProps} />}
        ></Route>
      </Route>

      <Route element={<JudgeOnly {...appProps} />}>
        <Route
          exact
          path="/judge"
          element={<JudgeDashboard {...appProps} />}
        ></Route>
      </Route>
      <Route element={<FinalJudgeOnly {...appProps} />}>
        <Route
          exact
          path="/final-judge"
          element={<FinalJudgeDashboard {...appProps} />}
        ></Route>
      </Route>
    </Routes>
  );
}
